import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import FONDO0 from "../assets/zero.jpg";
import FONDO1 from "../assets/one.jpg";
import FONDO2 from "../assets/two.jpg";
import FONDO3 from "../assets/three.jpg";
import FOOT from "../assets/espumaFondo.png";

const SectionOne = () => {
  const fondos = [FONDO0, FONDO1, FONDO2, FONDO3];

  return (
    <div className="relative w-full h-[85vh] overflow-hidden">
      {/* Swiper para fondos */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        className="absolute inset-0 w-full h-full"
      >
        {fondos.map((fondo, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${fondo})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Overlay negro */}
      <div className="absolute inset-0 bg-black/50 z-20" />

      {/* Contenido */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 z-40">
        <h1 className="text-3xl md:text-5xl font-bold text-white drop-shadow-lg">
          "EL LAVADO ES COSA NUESTRA"
        </h1>
        <p className="mt-4 text-lg md:text-xl text-white max-w-2xl drop-shadow">
          En Wash & Go, ven y lava la ropa de toda tu familia en 1 hora rápido,
          cómodo y económico, así que corre a tu sucursal más cercana y aprovecha
          lo que tenemos para ti
        </p>
      </div>

      {/* Espuma fija en el fondo */}
      <img
        src={FOOT}
        alt="espuma"
        className="absolute bottom-0 left-0 w-full object-cover pointer-events-none z-40"
      />
    </div>
  );
};

export default SectionOne;
